import { render, staticRenderFns } from "./PanelWithBudgetSummary.vue?vue&type=template&id=0fdc8644&lang=pug&"
import script from "./PanelWithBudgetSummary.vue?vue&type=script&lang=ts&"
export * from "./PanelWithBudgetSummary.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithBudgetSummary.vue?vue&type=style&index=0&id=0fdc8644&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports